import { TLocalesKeys } from '../localization';
import { EVerificationClubStatus } from '../types';

export enum ESubscription {
  STARTER = 'Starter',
  BUSINESS = 'Business',
  TRIAL = 'Trial',
  FREE = 'Free',
}

export type TFeature =
  | 'user_comments'
  | 'telegram_notify'
  | 'work_shift_events'
  | 'autostart'
  | 'goods'
  | 'pc_security'
  | 'virtual_hosts'
  | 'active_window'
  | 'cash_orders'
  | 'sold_items'
  | 'pc_status'
  | 'work_shift_income'
  | 'work_shift_stats'
  | 'wol'
  | 'applications'
  | 'per_minute_tariffs'
  | 'user_history'
  | 'user_discounts'
  | 'edit_deposit'
  | 'user_search'
  | 'game_accounts'
  | 'seance_end_action'
  | 'discounts'
  | 'package_tariffs'
  | 'auto_per_minute'
  | 'worker_tasks'
  | 'tech_support_vip'
  | 'pc_disk_usage'
  | 'shell_tariffs'
  | 'service_mode'
  | 'activity_rating'
  | 'game_accounts_widget'
  | 'abonements'
  | 'base_reports'
  | 'stock_refill'
  | 'services'
  | 'ai_tariffs'
  | 'change_host'
  | 'tech_support'
  | 'refunds'
  | 'work_shift_reports'
  | 'fast_deposit'
  | 'pc_comments'
  | 'host_map'
  | 'rmb_sell'
  | 'pc_disk_hide'
  | 'remote_exec'
  | 'cash_box'
  | 'tech_chat'
  | 'bonus_cash'
  | 'booking'
  | 'restrict_chrome_download'
  | 'removable_storage'
  | 'club_rules'
  | 'host_penalty'
  | 'host_notification'
  | 'shell_skin'
  | 'deposit_cashback'
  | 'self_host_change'
  | 'shell_skin_screensaver'
  | 'export_users'
  | 'call_admin'
  | 'club_review'
  | 'remote_control'
  | 'achievements'
  | 'combos'
  | 'client_transaction'
  | 'free_run'
  | 'holiday_tariffs'
  | 'customizable_permissions'
  | 'post_payments'
  | 'sbp_tinkoff'
  | 'sales_report'
  | 'visits_report'
  | 'usage_report'
  | 'smart_bonus'
  | 'user_report'
  | 'applications_report'
  | 'export_goods'
  | 'shell_goods_display'
  | 'register_without_verification'
  | 'kaspi_online'
  | 'deposit_transfer'
  | 'stripe'
  | 'tips'
  | 'fast_login'
  | 'club_news'
  | 'bonus_report'
  | 'host_hardware'
  | 'lite_shell'
  | 'copy_settings'
  | 'bepaid'
  | 'advertisement';

export interface IFeatureHOCProps {
  alias: TFeature;
  strategy?:
    | 'hide'
    | 'disable'
    | 'replace'
    | 'preview'
    | 'violetReplace'
    | 'fade';
  name?: string;
  fullHeight?: boolean;
  grayBG?: boolean;
  tooltipPosition?:
    | 'bottom-right'
    | 'bottom-left'
    | 'right'
    | 'bottom'
    | 'unset';
  fullWidth?: boolean;
  hideTitle?: boolean;
  nameKey?: TLocalesKeys;
  variant?: 'primary' | 'secondary';
}

export interface IGetFeaturesResponse {
  featureFlags: {
    modules: Array<TFeature>;
    subscription: ESubscription | null;
    host_count: number;
    expires_at: string;
    shortcuts_sync_enabled: boolean;
    it_adviser_support: boolean;
    company_owner: {
      inn: number;
    };
    verification: {
      status: EVerificationClubStatus;
    };
  };
}

export interface IFeaturesState {
  features: Array<TFeature>;
  subscription: ESubscription | null;
  expiresAt: string | null;
  host_count: number;
  isFeaturesInitialized: boolean;
  shortcuts_sync_enabled: boolean;
  it_adviser_support: boolean;
  company_owner: {
    inn: number;
  } | null;
  verification: {
    status: EVerificationClubStatus | null;
  };
}

export interface IFeatureContext extends IFeaturesState {
  loadFlags: (token?: string) => Promise<unknown>;
  clearFeatures: VoidFunction;
}
